import {getSessionToken} from 'utils/session'

const initialState = {
  discoveryPosts: [],
  ui: {
    headerShowLogin: true,
    headerTitle: 'Project Jumbotron',
    newOrganisationId: null,
    showArchived: true,
  },
  user: {
    session: getSessionToken() || null
  },
  popover: {
    open: false,
    data: undefined,
    componentName: undefined,
  },
  toast: {
    open: false,
    data: undefined,
    componentName: undefined
  },
  map: {
    loading: true,
    activeTrap: null,
    activeGroup: null,
    focusedTrap: null,
    focusedGroup: null,
    data: {
      groupLineDetails: null
    }
  },
  people: {
    approved: null,
    requests: null,
    selected: null
  },
  traps: {
    loading: true,
  },
  groups: {
    items: null,
    loading: false,
    selected: null,
    userItems: null,
    userItemsAll: null,
  },
  organisation: {
    items: null,
    selected: null
  },
  data: {
    overviewData: null,
  },
  progress: {}
}

export default initialState



// WEBPACK FOOTER //
// ./src/reducers/initialState.js